import React from 'react'
import Subheader from '../Subheader'
import Navbar from '../Navbar'
import ArrayProperty from './ArrayProperty'

function AllProperty() {
  return (
    <div>
        <Subheader/>
        <Navbar/>
        <ArrayProperty/>
    </div>
  )
}

export default AllProperty